import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { useAgGridDataSource } from 'hooks/useAgGridDataSource';

import { useEffect, useMemo } from 'react';

import { uerPriceListRatioUerRowsGql } from '../../PriceListFactors/factorsQueries';

const requestId = 'uerPriceListRatioUerRows';

const getWhereVariables = (filterValues?: Record<string, string[]>) => {
    if (!filterValues) {
        return undefined;
    }

    return {
        and: Object.entries(filterValues).reduce((acc: any, [key, value]) => {
            if (!value.length) {
                return acc;
            }

            if (value.length) {
                acc = [
                    ...acc,
                    {
                        [key]: { in: value },
                    },
                ];
            }

            return acc;
        }, []),
    };
};

export const useUerPriceListRatioUerRows = (ratioRowId: number, filterValues?: Record<string, string[]>) => {
    const [uerPriceListRatioUerRowsReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => ({
            ratioRowId,
            where: getWhereVariables(filterValues),
        }),
        [filterValues, ratioRowId],
    );

    const [uerPriceListRatioUerRowsData, uerPriceListRatioUerRowsStatus, , request] = useRequest({
        requestId,
        query: uerPriceListRatioUerRowsGql,
        variables,
    });

    const { dataSource, getRowParams } = useAgGridDataSource({
        requestId,
        requestFn: request,
        requestVariables: variables,
    });

    useEffect(() => {
        if (uerPriceListRatioUerRowsData?.uerPriceListRatioUerRows?.items && getRowParams?.current) {
            getRowParams?.current?.successCallback(
                uerPriceListRatioUerRowsData?.uerPriceListRatioUerRows?.items,
                uerPriceListRatioUerRowsData?.uerPriceListRatioUerRows?.totalCount ?? 0,
            );
        }
    }, [
        getRowParams,
        uerPriceListRatioUerRowsData?.uerPriceListRatioUerRows?.items,
        uerPriceListRatioUerRowsData?.uerPriceListRatioUerRows?.totalCount,
    ]);

    useEffect(() => {
        uerPriceListRatioUerRowsReset(undefined);
    }, [uerPriceListRatioUerRowsReset]);

    return {
        uerPriceListRatioUerRowsStatus,
        dataSource,
    };
};
